import axios from 'axios'

/*
 * Dedicated axios instance: no shared interceptors, so a failing /health
 * never triggers the global 401/403/404 redirects.
 */
const client = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
    timeout: 5000
})

export function fetchSystemHealth() {
    return client.get('/api/health')
}
